import styled from 'styled-components';
import { darken } from 'polished';
import colors from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 5rem;
  form {
    display: flex;
    flex-direction: column;
    p {
      margin-top: 1rem;
      font-size: 1rem;
    }
    button {
      margin-top: 1rem;
      height: 5rem;
      background-color: ${colors.primary};
      border-radius: 0.4rem;
      border: 0;
      color: #fff;
      font-size: 1.8rem;
      font-weight: bold;
      text-transform: uppercase;

      &:hover {
        background-color: ${darken(0.1, colors.primary)};
      }
    }
  }
`;

export const Group = styled.div`
  display: flex;
  padding: 5rem;
  @media (max-width: 370px) {
    padding: 2rem;
  }
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  label {
    font-size: 1.8rem;
    font-weight: bold;
    width: 50%;
    min-width: 20rem;
  }
  span {
    width: 50%;
    color: white;
    font-size: 1.2rem;
    padding: 1rem;
    font-weight: bold;
    margin-bottom: 3rem;
    width: 50%;
    min-width: 20rem;
    background-color: #c72931;
    border-bottom: 0.3rem solid ${darken(0.1, '#C72931')};
  }
  select > option {
    color: #ddd;
  }
  select,
  textarea,
  input {
    width: 50%;
    min-width: 20rem;
    height: 3.8rem;
    min-height: 3.8rem;
    border-radius: 0.4rem;
    border: 0;
    padding: 1rem;
    background-color: #f5f5f5;
    & + label {
      margin-top: 1rem;
    }
  }
`;

export const GroupHeader = styled.div`
  background-color: #f5f5f5;
  padding: 1.5rem;
  font-size: 1.6rem;
  font-weight: bold;

  ${Group} + & {
    margin-top: 1rem;
  }
`;

export const CheckRow = styled.div`
  width: 50%;
  min-width: 20rem;
  display: flex;
  flex-direction: column-reverse;
  input {
    width: 50px;
    height: 50px;
  }
`;
